import {Component, inject} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {MatDialogRef} from "@angular/material/dialog";
import {TranslateModule} from "@ngx-translate/core";
import {EventService} from "shared/event.service";

@Component({
    selector: 'app-freemium-premium-compare-access',
    imports: [
        MatIconModule,
        TranslateModule,
    ],
    templateUrl: './freemium-premium-compare-access.component.html'
})
export class FreemiumPremiumCompareAccessComponent {
    private eventService = inject(EventService);
    dialogRef = inject(MatDialogRef<FreemiumPremiumCompareAccessComponent>);
    action(userWantToBuyPremiumAccess: boolean) {
        if (userWantToBuyPremiumAccess){
            this.eventService.trackEvent('click button', 'go buy premium', 'premium');
        } else {
            this.eventService.trackEvent('click button', 'continue freemium', 'premium');
        }

        this.dialogRef.close(userWantToBuyPremiumAccess);
    }
}
